import { render, staticRenderFns } from "./newUserBackOffice.vue?vue&type=template&id=774da35b"
import script from "./newUserBackOffice.vue?vue&type=script&lang=js"
export * from "./newUserBackOffice.vue?vue&type=script&lang=js"
import style0 from "./newUserBackOffice.vue?vue&type=style&index=0&id=774da35b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports